import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Badge, Spinner } from 'react-bootstrap';
import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../services/api';
import ParentStudentDetails from './ParentStudentDetails';

const ParentChildren = () => {
  const [selectedStudentId, setSelectedStudentId] = useState(null);

  const { data: studentsResponse, isLoading } = useQuery({
    queryKey: ['parent_students'],
    queryFn: async () => {
      const response = await apiService.get('/api/parent/students');
      return response.data;
    }
  });

  const students = studentsResponse || [];

  useEffect(() => {
    if (students.length > 0 && !selectedStudentId) {
      setSelectedStudentId(students[0].id);
    }
  }, [students, selectedStudentId]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="mb-1">My Child</h4>
          <p className="text-muted mb-0">Manage and review your child&apos;s school information</p>
        </div>
      </div>

      <Row className="g-4">
        <Col xl={4} lg={5}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Header className="bg-white border-0">
              <h6 className="mb-0">
                <i className="bi bi-people me-2"></i>Children
              </h6>
            </Card.Header>
            <Card.Body>
              {isLoading ? (
                <div className="text-center py-4">
                  <Spinner animation="border" size="sm" />
                </div>
              ) : students.length === 0 ? (
                <div className="text-center py-5">
                  <i className="bi bi-people display-1 text-muted mb-4"></i>
                  <h5>No Children Found</h5>
                  <p className="text-muted">No children are currently associated with your account.</p>
                </div>
              ) : (
                <div className="d-flex flex-column gap-3">
                  {students.map((student) => {
                    const isActive = selectedStudentId === student.id;
                    return (
                      <Card
                        key={student.id}
                        className={`border ${isActive ? 'border-primary shadow-sm' : 'border-light'}`}
                        role="button"
                        onClick={() => setSelectedStudentId(student.id)}
                      >
                        <Card.Body className="d-flex align-items-center justify-content-between">
                          <div>
                            <h6 className="mb-1">{student.student_name}</h6>
                            <div className="text-muted small">
                              <i className="bi bi-hash me-1"></i>
                              {student.roll_number}
                            </div>
                            <div className="mt-2">
                              <Badge bg={isActive ? 'primary' : 'secondary'} className="me-2">
                                {student.grade_name}
                              </Badge>
                              <Badge bg="light" text="dark">
                                {student.division_name}
                              </Badge>
                            </div>
                          </div>
                          <i className={`bi bi-chevron-right ${isActive ? 'text-primary' : 'text-muted'}`}></i>
                        </Card.Body>
                      </Card>
                    );
                  })}
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col xl={8} lg={7}>
          <ParentStudentDetails studentId={selectedStudentId} />
        </Col>
      </Row>
    </div>
  );
};

export default ParentChildren;

